







































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Tache} from '@/models';

import CrudTacheEdit from '@/components/Crud/Tache/Edit.vue';

@Component({
	components: {
		CrudTacheEdit,
	}
})
export default class CrudTacheEditDialog extends Vue {
	@InOut({ type: Tache  , isVModel: true }) private value!: Tache;
	@InOut({ type: Boolean  , isVModel: false }) private route!: Boolean;

	@Emit()
	private onSubmit(tache: Tache) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		if (this.value.id)
		{
			if (this.route == true) {
				if (
					this.$route.name !== 'tache-show' ||
					this.$route.params["id"] !== this.value.id.toString()
				) {
					this.$router.push({name: 'tache-show', params: { id : this.value.id.toString() }});
				}
			}
		}
		this.value = null;
	}
}
